'use client';
import { useState } from 'react';

import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '@/slw/shared/ui/accordion';
import { Card, CardContent } from '@/slw/shared/ui/card';

export function BuyingCars() {
  const [open, setOpen] = useState(true);

  const triggerClass = 'md:pt-6 md:pb-4 py-4 text-sm md:text-base font-semibold leading-[100%] flex items-center';

  return (
    <Card className='rounded-2xl bg-[#F7F7F7] shadow-sm mb-8 border-0 p-6 md:p-8'>
      <div className='flex items-center justify-between'>
        <h3 className='text-xl md:text-[2rem] leading-[100%] font-bold text-foreground'>Buying Cars</h3>
        <button
          type='button'
          className='text-sm font-normal leading-[150%] text-muted-foreground hover:text-primary transition'
          onClick={() => setOpen((v) => !v)}
        >
          {open ? 'Hide' : 'Show'}
        </button>
      </div>
      {open && (
        <CardContent className='pt-0 px-0 pb-0'>
          <Accordion type='multiple' className='divide-y divide-[#E5E5E5]'>
            <AccordionItem value='need-account'>
              <AccordionTrigger className={triggerClass}>Do I need an account to browse listings?</AccordionTrigger>
              <AccordionContent className='pl-0 text-sm leading-[150%]'>
                No, you can freely browse all listings. However, creating a free account allows you to save vehicles,
                contact sellers, negotiate deals, receive alerts, and more.
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value='contact-seller'>
              <AccordionTrigger className={triggerClass}>How do I contact a seller?</AccordionTrigger>
              <AccordionContent className='pl-0 text-sm leading-[150%]'>
                Click “Contact Seller” on any listing to message them through our secure internal system. Once
                connected, you may continue your conversation by email or phone at your discretion.
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value='negotiate-price'>
              <AccordionTrigger className={triggerClass}>Can I make an offer or negotiate the price?</AccordionTrigger>
              <AccordionContent className='pl-0 text-sm leading-[150%]'>
                Yes. All listings include a messaging feature so you can discuss price, delivery, and terms directly
                with the seller. Clovis Classics does not interfere with your negotiations.
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value='financing'>
              <AccordionTrigger className={triggerClass}>Is financing available?</AccordionTrigger>
              <AccordionContent className='pl-0 text-sm leading-[150%]'>
                We currently do not offer in-house financing, but we do partner with lenders who specialize in classic
                car financing. Links to apply are available on each listing page (if the seller enables it).
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value='guarantee-condition'>
              <AccordionTrigger className={triggerClass}>
                Does Clovis Classics guarantee the condition of the cars?
              </AccordionTrigger>
              <AccordionContent className='pl-0 text-sm leading-[150%]'>
                All vehicles are listed and described by the sellers. We encourage buyers to request inspections, verify
                documentation, and use escrow or transport services for added peace of mind. Clovis Classics is not
                responsible for the vehicle’s condition or terms of the sale.
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </CardContent>
      )}
    </Card>
  );
}
